import { UserAuthSessionsTableHeadRow } from "./TableHeadRow.js";
import { UserAuthSessionsTableRow } from "./TableRow.js";
import { UserAuthSessionsTableControls } from "./TableControls.js";
import { useMemo, useState } from "react";
import { DinnerTable, Pagination } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Users/shared/UserAuthSessionsTable/index.tsx
function UserAuthSessionsTable({ data, onClickAuthSessionClientApps, onKillSelectedAuthSessions, onTestPushNotification, recordsPerPage, setRecordsPerPage, setSkippedRecords, showUserName = false, skippedRecords, totalRecords }) {
	const [selectedRowKeys, setSelectedRowKeys] = useState();
	const [rowKeys, setRowKeys] = useState([]);
	const handleToggleRowSelection = (rowKey) => {
		setSelectedRowKeys((prevSelected) => {
			if (prevSelected?.includes(rowKey)) return prevSelected.filter((key) => key !== rowKey);
			else return [...prevSelected || [], rowKey];
		});
	};
	useMemo(() => {
		data?.forEach((authSession) => {
			if (authSession.publicId && !rowKeys.includes(authSession.publicId)) setRowKeys((prevKeys) => [...prevKeys, authSession.publicId]);
		});
	}, [data]);
	const handleSelectAllRows = () => {
		if (rowKeys.length === selectedRowKeys?.length) setSelectedRowKeys(void 0);
		else setSelectedRowKeys(rowKeys);
	};
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		!!selectedRowKeys?.length && /* @__PURE__ */ jsx(UserAuthSessionsTableControls, {
			onKillSelectedAuthSessions,
			selectedRowsKeys: selectedRowKeys,
			clearSelectedRows: () => setSelectedRowKeys(void 0)
		}),
		/* @__PURE__ */ jsxs(DinnerTable, { children: [/* @__PURE__ */ jsx(UserAuthSessionsTableHeadRow, {
			allRowsSelected: rowKeys.length === selectedRowKeys?.length,
			onSelectAllRows: handleSelectAllRows,
			showUserName
		}), /* @__PURE__ */ jsx(DinnerTable.Body, { children: data?.map((authSession) => /* @__PURE__ */ jsx(UserAuthSessionsTableRow, {
			rowData: authSession,
			onClickAuthSessionClientApps,
			onTestPushNotification,
			showUserName,
			selectedRowKeys,
			onSelectRow: handleToggleRowSelection
		}, authSession.id)) })] }),
		/* @__PURE__ */ jsx(Pagination, {
			onPageClick: setSkippedRecords,
			onSetRecordsPerPage: setRecordsPerPage,
			recordsPerPage,
			showDescription: true,
			skippedRecords,
			totalRecords
		})
	] });
}
//#endregion
export { UserAuthSessionsTable };

//# sourceMappingURL=index.js.map